
import React from 'react';
import { DiagnosticsProvider } from './DiagnosticsContext';
import DiagnosticsStats from './DiagnosticsStats';
import DiagnosticsFilters from './DiagnosticsFilters';
import DiagnosticsTable from './DiagnosticsTable';

const BikeInconsistenciesAnalytics: React.FC = () => {
  return (
    <DiagnosticsProvider>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold">Полная диагностика системы</h2>
            <p className="text-muted-foreground mt-1">
              Комплексный анализ всех компонентов системы с данными с 1 июня 2025 года
            </p>
          </div>
        </div>
        
        <DiagnosticsStats />
        <DiagnosticsFilters />
        <DiagnosticsTable />
      </div>
    </DiagnosticsProvider>
  );
};

export { BikeInconsistenciesAnalytics };
export default BikeInconsistenciesAnalytics;
